/**
 * @file HOC for setting starting album folder on discover mode.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { onSetAlbumFolder as onSetAlbumFolderAction } from '../../../actions/discover-album-folder';

const WithSetAlbumFolder = WrappedComponent =>
  class extends Component {
    static propTypes = {
      albumFolderId: PropTypes.string,
      onSetAlbumFolder: PropTypes.func.isRequired,
    };

    constructor(props) {
      super(props);

      const { albumFolderId, onSetAlbumFolder } = this.props;

      if (!albumFolderId) {
        onSetAlbumFolder();
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

const mapStateToProps = ({ discoverAlbumFolder }) => ({
  albumFolderId: discoverAlbumFolder.albumFolderId,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSetAlbumFolder: () =>
    dispatch(onSetAlbumFolderAction(ownProps.match.params.albumFolderId)),
});

export { WithSetAlbumFolder };

export default WrappedComponent => {
  return compose(
    connect(mapStateToProps, mapDispatchToProps),
    WithSetAlbumFolder,
  )(WrappedComponent);
};
